<template>
  <div class="w-100 d-flex flex-column" style="gap: 56px;">

    <div class="financial-summary d-flex flex-column" style="gap: 24px;">
      <div class="title d-flex">
        <h5>{{ $t("views.seller.my_account.text_1231") }}</h5>
        <!-- <span v-if="bankAccount.status" :class="['tag-status', 'ml-0', 'ml-2', convertStatus(bankAccount.status)]">
          {{ $t(`views.seller.my_account.status.${convertStatus(bankAccount.status)}`) }}
        </span> -->
      </div>
      <div class="financial-summary d-flex flex-column" style="gap: 24px;">
        <div class="financial-summary-table d-flex flex-column">
          <div class="financial-summary-table-header d-flex align-items-center">
            <p>{{ $t('seller.statements.modals.bank_account.text_2722') }}</p>
          </div>
          <div class="financial-summary-table-body d-flex align-items-center flex-column">
            <div class="financial-summary-table-row d-flex w-100 justify-content-between">
              <div class="financial-summary-table-cell d-flex flex-column">
                <div class="d-flex flex-column" style="gap: 8px">
                  <div>
                    <p class="font-weight-bold">{{ bankAccount.bank_name }}</p>
                    <p>{{ $t('views.seller.my_account.bank_account.text_1297') }}: {{ bankAccount.agency }}</p>
                    <p>{{ $t('views.seller.my_account.bank_account.text_1301') }}: {{ bankAccount.account }}-{{
                      bankAccount.account_dv }}</p>
                    <p>{{ $t('views.seller.my_account.bank_account.text_1315') }}: {{ bankAccount.name }}</p>
                    <a 
                      v-if="bankDocument" 
                      :href="bankDocument.url" 
                      target="_blank"
                      class="text-decoration-none"
                    >
                      {{ bankDocument.name }}.{{ getExtension(bankDocument.path) }}
                    </a>
                  </div>
                  <div class="d-flex align-item-center">
                    <span v-if="bankDocument" :class="['tag-status', 'ml-0', 'mr-2', convertStatus(bankDocument.status)]">
                      {{ $t(`views.seller.my_account.status.${convertStatus(bankDocument.status)}`) }}
                    </span>
                    <p v-if="bankDocument.pending_motive">{{ $t('views.seller.my_account.text_1314') }}: {{ bankDocument.pending_motive }}</p>
                  </div>
                </div>
              </div>
              <div class="my-fees-table-cell d-flex" style="min-width: 100px;">
                <BaseNewButton
                  v-if="showEdit"
                  variant="secondary" 
                  icon="edit-2" 
                  iconPosition="left" 
                  type="button"
                  @click="handleEdit(2)"
                >
                  {{ $t("views.seller.my_account.text_1313") }}
                </BaseNewButton>
              </div>
            </div>
          </div>
          <div class="financial-summary-table-footer d-flex align-items-center">
            <p v-if="isPersonal">{{ $t("views.seller.my_account.text_1159") }}</p>
            <p v-if="isBusiness">{{ $t("views.seller.my_account.text_1320") }}</p>
          </div>
          <div class="financial-summary-table-body d-flex align-items-center flex-column">
            <div class="financial-summary-table-row d-flex w-100 justify-content-between">
              <div class="financial-summary-table-cell d-flex flex-column">
                <div class="d-flex flex-column" style="gap: 8px">
                  <div>
                    <p class="font-weight-bold">{{ data.name }}</p>
                    <p>
                      {{ isBusiness 
                        ? $t('views.seller.my_account.text_1316') 
                        : $t('views.seller.my_account.text_1315')}}: {{ data.document }}
                    </p>
                    <div class="d-flex flex-column" style="gap: 8px">
                      <div
                        class="d-flex"
                        style="gap: 4px"
                        v-if="documents" 
                        v-for="document in documents || []" 
                      >
                        <div class="d-flex" style="gap: 4px" v-if="document.status">
                          <a
                            target="_blank"
                            :href="document.url" 
                            class="text-decoration-none"
                          >
                            {{ document.name }}
                          </a>
                          <div v-if="document" class="d-flex align-items-center">
                            <span :class="['tag-status', 'ml-0', 'mr-2', 'd-inline', convertStatus(document.status)]">
                              {{ $t(`views.seller.my_account.status.${convertStatus(document.status)}`) }}
                            </span>
                            <p v-if="document.pending_motive">{{ $t('views.seller.my_account.text_1314') }}: {{ document.pending_motive }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-fees-table-cell d-flex" style="min-width: 100px;">
                <BaseNewButton 
                  v-if="showEdit"
                  variant="secondary" 
                  icon="edit-2" 
                  iconPosition="left" 
                  type="button"
                  @click="handleEdit(1)"
                >
                  {{ $t("views.seller.my_account.text_1313") }}
                </BaseNewButton>
              </div>
            </div>
          </div>
          <div class="financial-summary-table-footer d-flex align-items-center">
            <p>{{ $t("views.seller.my_account.text_1312") }}</p>
          </div>
          <div class="financial-summary-table-body d-flex align-items-center flex-column">
            <div class="financial-summary-table-row d-flex w-100 justify-content-between">
              <div class="financial-summary-table-cell d-flex flex-column">
                <div class="d-flex flex-column" style="gap: 8px">
                  <div class="d-flex flex-column" style="gap: 8px">
                    <div>
                      <p class="font-weight-bold">{{ $t("views.seller.my_account.text_1578") }}: {{ address.zip_code }}
                      </p>
                      <p>{{ address.street }}, {{ address.number }}</p>
                      <p>{{ address.neighborhood }}</p>
                      <p>{{ address.city }} - {{ address.state }}</p>
                      <a 
                        v-if="addressProof" 
                        :href="addressProof.url" 
                        class="text-decoration-none"
                        target="_blank"
                      >
                        {{ addressProof.name }}.{{ getExtension(addressProof.path) }}
                      </a>
                    </div>
                    <div v-if="addressProof" class="d-flex align-item-center">
                      <span :class="['tag-status', 'ml-0', 'mr-2', convertStatus(addressProof.status)]">
                        {{ $t(`views.seller.my_account.status.${convertStatus(addressProof.status)}`) }}
                      </span>
                      <!-- <p>{{ $t('views.seller.my_account.text_1314') }}: </p> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-fees-table-cell d-flex" style="min-width: 100px;">
                <BaseNewButton 
                  v-if="showEdit"
                  variant="secondary" 
                  icon="edit-2" 
                  iconPosition="left" 
                  type="button"
                  @click="handleEdit(0)"
                >
                  {{ $t("views.seller.my_account.text_1313") }}
                </BaseNewButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadService from '@/services/resources/DownloadService';
import download from '@/utils/download';

const downloadService = DownloadService.build();

export default {
  name: 'FinancialDataSummary',
  props: {
    bankAccount: {
      type: Object,
      required: true
    },
    myAccount: {
      type: Object,
      required: true
    },
    identityValidation: {
      type: Object,
      required: true
    }
  },
  computed: {
    data() {
      if (this.isBusiness) {
        return {
          name: this.myAccount.company.name,
          document: this.myAccount.company.cnpj,
        }
      };
      if (this.isPersonal) {
        return {
          name: this.myAccount.user.name,
          document: this.myAccount.user.cpf_cnpj
        }
      };
      return {
        name: '',
        document: ''
      };
    },
    showEdit() {
      if (!this.bankAccount) {
        return false;
      }
      if (this.bankAccount.status === null) {
        return false;
      }
      if (['PROCESSING', 'APPROVED', 'REQUESTED'].includes(this.bankAccount.status)) {
        return false;
      }
      return true;
    },
    isBusiness() {
      return this.bankAccount.account_type === 'BUSINESS';
    },
    isPersonal() {
      return this.bankAccount.account_type === 'PERSONAL';
    },
    address() {
      if (this.isBusiness) {
        return {
          zip_code: this.myAccount.company.zip_code,
          street: this.myAccount.company.street,
          number: this.myAccount.company.number,
          neighborhood: this.myAccount.company.neighborhood,
          city: this.myAccount.company.city,
          state: this.myAccount.company.state,
        }
      }

      if (this.isPersonal && this.myAccount.user.address) {
        return {
          zip_code: this.myAccount.user.address.zip_code,
          street: this.myAccount.user.address.street,
          number: this.myAccount.user.address.number,
          neighborhood: this.myAccount.user.address.neighborhood,
          city: this.myAccount.user.address.city,
          state: this.myAccount.user.address.state,
        }
      }
      return {
        zip_code: '',
        street: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
      }
    },
    hasDocuments() {
      if (!this.myAccount.user) {
        return false;
      }
      if (!this.myAccount.user.documents) {
        return false;
      }
      return this.myAccount.user.documents.length;
    },
    addressProof() {
      if (!this.hasDocuments) {
        return null;
      }

      let documents = [];

      if (this.isBusiness) {
        documents = this.getDocuments('COMPANY_DOCUMENT');
      } else {
        documents = this.getDocuments('USER_DOCUMENT');
      }

      const files = documents.filter(document => document.subtype === 'PROOF_ADDRESS');

      if (!files.length) {
        return null;
      }
      return {
        ...files[files.length - 1],
        name: this.$t('views.seller.my_account.text_1343')
      };
    },
    businessDocuments() {
      const documents = this.getDocuments('COMPANY_DOCUMENT');

      if (documents && documents.length) {
        return documents.filter(document => 
          !(document.subtype 
            && document.subtype === 'PROOF_ADDRESS'
            || document.subtype === null
          ))
        .map((document, index) => ({
          ...document,
          name: document.subtype
            ? this.$t('views.seller.my_account.document_type.' + document.subtype.toLowerCase()) + '.' + this.getExtension(document.path)
            : `company-document-${index + 1}.` + this.getExtension(document.path)
        }));
      }
      return null;
    },
    userDocuments() {
      const documents = this.getDocuments('USER_DOCUMENT');

      if (documents && documents.length) {
        return documents.filter(document => 
          !(document.subtype 
            && document.subtype === 'PROOF_ADDRESS'
            || document.subtype === null
          ))
        .map((document, index) => ({
          ...document,
          name: document.subtype
            ? this.$t('views.seller.my_account.document_type.' + document.subtype.toLowerCase()) + '.' + this.getExtension(document.path)
            : `user-document-${index + 1}.` + this.getExtension(document.path)
        }));
      }
      return null;
    },
    identityDocuments() {
      const docs = [];
      if (this.identityValidation.doc_front) {
        docs.push({
          name: this.$t('views.seller.my_account.document_type.identification') + '.' + this.getExtension(this.identityValidation.doc_back),
          path: this.identityValidation.doc_front,
          url: this.identityValidation.doc_front_url,
          status: this.identityValidation.doc_front_status
        });
      }
      if (this.identityValidation.doc_back) {
        docs.push({
          name: this.$t('views.seller.my_account.document_type.selfie') + '.' + this.getExtension(this.identityValidation.doc_back),
          path: this.identityValidation.doc_back,
          url: this.identityValidation.doc_back_url,
          status: this.identityValidation.doc_back_status,
        });
      }
      return docs;
    },
    documents() {
      if (!this.hasDocuments) {
        return [];
      }

      if (this.isBusiness) {
        return [...this.businessDocuments, ...this.identityDocuments];
      }
      return [...this.userDocuments, ...this.identityDocuments];
    },
    bankDocument() {
      if (!this.hasDocuments) {
        return null;
      }

      if (!this.bankAccount.last_document) {
        return null;
      }
      return {
        ...this.bankAccount.last_document,
        name: this.$t('views.seller.my_account.document_type.bank_account_proof')
      }
    }
  },
  methods: {
    handleEdit(step) {
      this.$root.$emit('on-edit', { modeEdit: true, step, isBusiness: this.isBusiness });
    },
    async downloadFile(path, fileName) {
      this.$bvToast.toast(
        this.$t('views.seller.my_account.text_1345'),
        {
          title: this.$t('views.seller.my_account.text_1344'),
          variant: 'success',
          autoHideDelay: 700,
          appendToast: true,
        }
      );
      try {
        const blob = await downloadService.blob({ url: path });

        download(blob, fileName);
      } catch (error) {
        console.log('FinancialDataSummary - download', error);
      }
    },
    getDocuments(type, subtype = null) {
      if (!this.hasDocuments) {
        return [];
      }
      if (subtype) {
        return this.myAccount.user.documents
          .filter(document => (document.type === type) && (document.subtype === subtype));
      }
      return this.myAccount.user.documents
        .filter(document => document.type === type);
    },
    getExtension(path) {
      if (!path) {
        return '';
      }
      return path.split('.').pop();
    },
    convertStatus(status) {
      switch (status) {
        case 'REQUESTED':
          return 'in_progress';
        case 'APPROVED':
          return 'approved';
        case 'DISAPPROVED':
          return 'rejected';
        case 'PROCESSING':
          return 'in_progress';
        default:
          return 'in_progress';
      }
    }
  }
};
</script>

<style scoped>
.financial-summary-table {
  border-radius: 8px;
  border: 1px solid var(--Default-gray-200, #E5E7EB);
  background: var(--Default-white, #FFF);

}

.financial-summary-table p {
  color: var(--Default-gray-900, #111827) !important;
}

.financial-summary-table a {
  color: var(--Default-primary-800, #0854C5);
  font-weight: 500;
}

.financial-summary-table-header {
  height: 44px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
  background: var(--Default-gray-100, #F3F4F6);
}

.financial-summary-table-header p {
  color: var(--Default-gray-900, #111827) !important;
  font-weight: 600;
}

.financial-summary-table-body .financial-summary-table-row {
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
}

.financial-summary-table-body .financial-summary-table-row:last-child {
  border-bottom: none;
}

.financial-summary-table-cell {
  display: flex;
  padding: 24px;
  align-items: center;
  align-self: stretch;
}

.financial-summary-table-footer {
  height: 44px;
  padding: 12px 24px;
  border-top: 1px solid var(--Default-gray-200, #E5E7EB);
  border-bottom: 1px solid var(--Default-gray-200, #E5E7EB);
  background: var(--Default-gray-100, #F3F4F6);
}

.financial-summary-table-footer p {
  color: var(--Default-gray-900, #111827) !important;
  font-weight: 600;
}
</style>